import { createContext, useState } from "react";

export const WeeklyContext = createContext();

function WeeklyContextProvider(props) {
	const [week, setWeek] = useState();
	const [topic, setTopic] = useState("");
	const [courseId, setCourseId] = useState();
	const [id, setId] = useState("");
	const [result, setResult] = useState([]);
	const [assignmentId, setAssignmentId] = useState();
	const [assignmentName, setAssignmentName] = useState();
	const [assignmentType, setAssignmentType] = useState([]);
	const [assignmentIdType, setAssignmentIdType] = useState();
	const [assignmentNameType, setAssignmentNameType] = useState();
	const [allQuestions, setAllQuestions] = useState([]);
	const [questionId, setQuestionId] = useState();
	return (
		<WeeklyContext.Provider
			value={{
				week,
				setWeek,
				topic,
				setTopic,
				courseId,
				setCourseId,
				id,
				setId,
				result,
				setResult,
				assignmentId,
				setAssignmentId,
				assignmentName,
				setAssignmentName,
				assignmentType,
				setAssignmentType,
				assignmentIdType,
				setAssignmentIdType,
				assignmentNameType,
				setAssignmentNameType,
				allQuestions,
				setAllQuestions,
				questionId,
				setQuestionId,
			}}
		>
			{props.children}
		</WeeklyContext.Provider>
	);
}

export default WeeklyContextProvider;
